/** localStorage kann im privaten Modus oder bei blockierten Website-Daten werfen. */
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key: string, value: string | null): void {
  try {
    if (value === null) {
      window.localStorage.removeItem(key);
    } else {
      window.localStorage.setItem(key, value);
    }
  } catch {
    // Ohne Speicher funktioniert die App weiter, nur ohne „angemeldet bleiben“.
  }
}
